import { TmrBaseResource } from 'stylewhere/api'

export class SortingGroupEntries extends TmrBaseResource {
  static endpoint = 'api/v1/sortinggroupentries' //logistics/
}
